import { render, staticRenderFns } from "./MduiSlider.vue?vue&type=template&id=5ff89c1f"
import script from "./MduiSlider.vue?vue&type=script&lang=js"
export * from "./MduiSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports